import { destroy, init, preview } from './mount';

/**
 * Embed: <script src=".../widget.js" data-key="wk_..." data-api="https://api.example.com" async></script>
 * or call window.VixSyncWidget.init({ key }) manually.
 */
const script = document.currentScript as HTMLScriptElement | null;
const key = script?.dataset.key;

if (key) {
  const start = () =>
    init({
      key,
      ...(script?.dataset.api ? { apiUrl: script.dataset.api } : {}),
      ...(script?.dataset.position === 'left' ? { position: 'left' as const } : {}),
    });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}

export { destroy, init, preview };
